module.exports = __webpack_public_path__ + "static/media/dmi_desktop.a677cc21.svg";